import {CollageTextObjectModel} from './collage-text-object.model';
import {CollageImageModel} from './collage-image.model';
// import {CollageItem} from "../image-collage.component";

export class CollagePageModel {
  index: number;
  tabName: string;
  // items: CollageItem[] = [];
  listOfTextObjects: CollageTextObjectModel[];
  listOfImages: CollageImageModel[];
}
